.m-reconnectingIcon-d8302f01d7{width:24px;height:24px}